import { Component, OnInit } from '@angular/core';
import { UploadService } from '../../services/upload/upload.service';
import { documentInformation } from '../../model/document.model';

@Component({
  selector: 'app-upload-control-test',
  templateUrl: './upload-control-test.component.html',
  styleUrls: ['./upload-control-test.component.css']
})
export class UploadControlTestComponent implements OnInit {
  documentInfo: documentInformation;
  notvalidImage: Boolean;
  signedUrl;
  constructor(private uploadService: UploadService) { }

  ngOnInit() {
  }
  setFileData(docInfo) {
    this.documentInfo = docInfo;
  }

  signedURL() {
    let body = {
      "filename": "Agent/10020/duediligence/file15mb.pdf"
    }
    let sizeOfFile = this.documentInfo.file.size;

    sizeOfFile = Math.ceil(sizeOfFile / (1024 * 1024));
    const defaultsize = 10;
    this.uploadService.getSignedURL(body).subscribe((res) => {
      this.signedUrl = res.Info;
      this.saveDocument(res.Info);
    })
  }
  saveDocument(url) {
    this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, url).subscribe((obj) => {
    }, (err) => {
     
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/upload-control-test/upload-control-test.component.ts